
import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { City } from '@/common/interface';
import ShopLicenseField from '@/views/shop/components/shopFieldTemplate/ShoplicenseField.vue';
import { BASE_URL } from '@/common/constant';
import lazyInject from '@/di';
import UserService from '@/services/user.service';
import { ISPUImageUploadOptions } from '@/common/interface/spu';
import { $delay } from '@/common/utils';
import moment from 'moment';
import { component as Viewer } from 'v-viewer';

interface IImage {
  id: string;
  url: string;
  order?: number;
}

@Component({
  components: {
    ShopLicenseField,
    Viewer,
  },
})
export default class InformationOnTheLocationOfTheVehicleSourceField extends Vue {
  @Ref()
  childFormRef!: FormModel;

  @lazyInject(UserService)
  userService!: UserService;

  moment = moment;

  watchable = true;


  @Prop()
  disabled!: boolean;


  @Prop()
  readonly!: boolean;

  BASE_URL = BASE_URL;

  token: string | undefined = undefined;

  val: IImage[] = [];

  uploading = false;

  formModel: any = {
    carPurchaser: '',
    carSource: '',
    purchasePrice: undefined,
    carPurchaseDate: '',
    vehicleSource: [],
    valuer: '',
    procureProof: [],
    carKey: '',
  };


  /** 上传配置 */
  optionsUpload: ISPUImageUploadOptions = {
    allowDuplicateUploads: false,
    target: `${BASE_URL}/tool/upload`,
    testChunks: false,
    headers: {},
    chunkSize: 5 * 1024 * 1024,
  };

  @Prop({ default: [] })
  citys!: City[];

  @Prop({ default: [] })
  options!: Array<{ id: number; name: string; city: City[] }>;

  rules = {
    vehicleSource: [
      { required: true, message: '请选择车源所在地' },
      {
        validator: (rule: any, value: any, callback: any) => {
          if (value.length < 2) {
            callback(new Error('车源地最少需要到市级'));
          } else {
            callback();
          }
        },
      },
    ],
  };

  public async validateFields(): Promise<boolean> {
    try {
      const valid = await (this.childFormRef as any).validate();
      return valid;
    } catch (error) {
      // console.error('子表单校验失败:', error);
      return false;
    }
  }

  carSourceOptions: any = [];

  onChange() {
    // console.log(value);
  }

    getLabel(arr: any, val: any) {
    let _text = '';
    arr.forEach((res: any) => {
      if (res.value === val) {
        _text = res.label;
      }
    });
    return _text;
  }

  onChangeCommercial(value: any) {
    this.formModel.carPurchaseDate = moment(value).format('YYYY-MM-DD');
  }

  @Watch('formModel.plateCityId')
  watchPlateCityId() {
    this.watchFormModel();
  }

  watchFormModel() {
    // this.$emit('update', this.formModel);
  }

  @Prop()
  value!: any;

  @Watch('value')
  handleValueChange() {
    this.formModel = this.value;
    // console.log(this.value, 'TMD');
    if (!this.formModel.purchasePrice) {
      this.formModel.purchasePrice = undefined;
    }
  }

  breakDown(val: any) {
    const _a: any = [];
    Object.keys(val).forEach((key) => {
      _a.push({
        value: Number(key),
        label: val[key],
      });
    });
    return _a;
  }
  mounted() {
    this.handleValueChange();
    const carFields = JSON.parse(localStorage.getItem('carFields') || '{}');
    const { car_source } = carFields;
    this.carSourceOptions = this.breakDown(car_source);
  }


  created() {
    this.optionsUpload.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }


  beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('请上传 png/jpeg 格式的照片!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('照片必须小于5MB!');
    }
    return isJpgOrPng && isLt5M;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onUploadChange(info: any, idx: number) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      const result = {
        id: data[0]?.id,
        url: data[0]?.url,
      };
      this.formModel.procureProof.splice(idx, 1, result);
      this.uploading = false;
    }
  }
}

